import { 
    GET_NOTICE_BOARD,
    POST_NOTICE_BOARD,
    PUT_NOTICE_BOARD,
    PATCH_DELETE_NOTICE_BOARD,
    POST_SET_VIEWED,
    PATCH_STARRED,
    PATCH_FILE,
    SET_FAVORITE, 
    SET_TABLE, 
    OPEN_NEW_MODAL, 
    OPEN_EDIT_MODAL, 
    OPEN_EDIT_TOOLTIP, 
    CLOSE_EDIT_TOOLTIP,  
    OPEN_VIEW_FULLPAGE,
    CLOSE_NEW_MODAL, 
    CLOSE_EDIT_MODAL, 
    SET_CHECKED, 
    OPEN_LINK,
    SEARCH_NOTICE, 
    //GET_NOTICES,
    SET_NOTICE_TAB_NUM,
    FILTER_CHECKBOX,
    IS_VIEWED,
    SET_SEEN_BY,
    UPDATE_NOTICE,
    NOTICE_BOARD_DATA_LIST,
    CREATE_NOTICE_BOARD,
    NOTICE_BOARD_ATTACHMENT,
    NOTICE_BOARD_UPDATE_ATTACHMENT,
    MODAL_DELETE_NOTICE_ACTION,
    HANDLE_MODAL_HOOK,
    DELETE_NOTICE_ACTION,
    NOTICES_GET_PROJECTS,
    NOTICES_GET_PRIVATE_GROUP_TYPE,
} from 'app/store/actions/notices/notices.actions';

const initialState = {
    postNoticeBoard: [],
    getNoticeBoard:[],
    putNoticeBoard:[],
    patchDeleteNoticeBoard:[],
    postSetViewed: null,
    patchStarred: null,
    patchFile:null,
    modalNewNotice: {
        type: 'new', 
        open: false
    },
    toolTipNoticeOpen: false,
    tableData: [],
    selectedRow: -1,
    searchNotice: '',
    tabNum: 0,
    searchFilterCheckbox: [],
    noticeDataList:[],
    newAttachment: [],
    upDateAttachment:[],
    handleModalHook: false,
    notices_getProjects: [],
    notices_getGroupTypePrivate: [],

    isSeenBy: [
        {index: 0, user: 'Uttam Dwivedi', initial:'UD', bg_color:'#5BB2B8', email: 'uttam@ad-hzm.co.jp', isViewed: false, isCreator: true,},
        {index: 1, user: 'Arthur Morgan', initial:'AM', bg_color:'#C9BC78', email: 'arthur.morgan@ad-hzm.co.jp', isViewed: true, isCreator: false,},
        {index: 2, user: 'Julien', initial:'J', bg_color:'#B85B5B', email: 'julien@ad-hzm.co.jp', isViewed: false, isCreator: false,},
        {index: 3, user: 'Tron', initial:'T', bg_color:'#C9BC78', email: 'tron@ad-hzm.co.jp', isViewed: true, isCreator: false,},
        {index: 4, user: 'Clue', initial:'C', bg_color:'#7191C1', email: 'clue@ad-hzm.co.jp', isViewed: false, isCreator: false,},
        {index: 5, user: 'Nick Kamimura', bg_color:'#7191C1', initial:'NK', email: 'nick@ad-hzm.co.jp', isViewed: true, isCreator: false,},
        {index: 6, user: 'Koderboxx', bg_color:'#B85B5B', initial:'K', email: 'koderboxx@ad-hzm.co.jp', isViewed: true, isCreator: false,},
        {index: 3, user: 'Dutch Van Der Linde', initial:'DV', bg_color:'#5BB2B8', email: 'dutch@ad-hzm.co.jp', isViewed: true, isCreator: false,},
        {index: 4, user: 'Andrew Milton', initial:'AM', bg_color:'#7191C1', email: 'andrew@ad-hzm.co.jp', isViewed: false, isCreator: false,},
        {index: 5, user: 'John Marston', bg_color:'#5BB2B8', initial:'JM', email: 'john@ad-hzm.co.jp', isViewed: false, isCreator: false,},
    ],
}

    
const noticesReducer = (state = initialState, action) =>{
    switch (action.type){
        case GET_NOTICE_BOARD: {
			return {
				...state,
				getNoticeBoard: action.payload,
			};
        }
        case POST_NOTICE_BOARD: {
			return {
				...state,
				postNoticeBoard: action.payload,
			};
        }
        case PUT_NOTICE_BOARD: {
			return {
				...state,
				puttNoticeBoard: action.payload,
			};
        }
        case PATCH_DELETE_NOTICE_BOARD: {
			return {
				...state,
				patchDeleteNoticeBoard: action.payload,
			};
        }
        case POST_SET_VIEWED: {
			return {
				...state,
				postSetViewed: action.payload,
			};
        }
        case PATCH_STARRED: {
			return {
				...state,
				patchStared: action.payload,
			};
        }
        case PATCH_FILE: {
			return {
				...state,
				patchFile: action.payload,
			};
        }
        
        case SET_TABLE: {
            return {
                ...state,
                tableData: action.payload
            };
        }
        case OPEN_NEW_MODAL: {
            return {
                ...state,
                modalNewNotice:{
                    type: 'new',
                    open: true,
                },
                selectedRow: -1,
            }

        }
        case CLOSE_NEW_MODAL:{
            return{
                ...state,
                modalNewNotice:{
                    type: 'new',
                    open: false,
                },
                selectedRow: -1,
            };
        }
        case CLOSE_EDIT_TOOLTIP:{
            return{
                ...state,
                toolTipNoticeOpen: false, 
                selectedRow: -1
            }
        }
        case OPEN_VIEW_FULLPAGE:{
            return{
                ...state,
                toolTipNoticeOpen: false, 
                selectedRow: action.payload,
            }
        }
        case OPEN_EDIT_MODAL:{
            return {
                ...state,
                modalNewNotice:{
                    type: 'edit',
                    open: true,
                },
                selectedRow: action.payload,
            };
        }
        case OPEN_EDIT_TOOLTIP:{
            return {
                ...state,
                toolTipNoticeOpen:true, 
                selectedRow: action.payload,
            };
        }
        case CLOSE_EDIT_MODAL:{
            return{
                ...state,
                modalNewNotice:{
                    type:'edit',
                    open: false,
                },
                selectedRow: -1,
            };
        }
        case SET_CHECKED: {
            let newData = [];
            for(let i=0; i<state.tableData.length; i++) {
                newData.push(state.tableData[i]);
                if(i === state.selectedRow) {
                    newData[i].isImportant = action.payload;
                }
            }
            return {
                ...state,
                tableData: newData,
            }
        }
        case SET_FAVORITE:{
            const index = state.tableData.findIndex((list) => list.index === action.payload); //finding index of the item
            console.log('REDUCER INDEX -->', index)
            let newArray = [...state.tableData]; //making a new array
            newArray[index].isFavorite = !newArray[index].isFavorite//changing value in the new array
            return { 
                ...state, //copying the orignal state
                tableData: newArray, //reassingning todos to new array
            }

        }
        case IS_VIEWED:{
            //const index = state.tableData.findIndex((list) => list.index === action.payload); //finding index of the item
            let newArray = [...state.tableData]; //making a new array
            // newArray[index].isViewed = true//changing value in the new array
            return { 
                ...state, //copying the orignal state
                tableData: newArray, //reassingning todos to new array
            }
        }
        case OPEN_LINK:{
            return{
                modalNewNotice:{
                    type:'edit',
                    open: false,
                },
                toolTipNoticeOpen: false,
            };
        }
        case SEARCH_NOTICE: {
			return {
				...state,
				searchNotice: action.searchNotice,
			};
		}
        case SET_NOTICE_TAB_NUM: {
            return {
                ...state,
                tabNum: action.payload,
            }
        }
        case FILTER_CHECKBOX: {
			return {
				...state,
				searchFilterCheckbox: action.payload,
			};
        }
        case SET_SEEN_BY:{
            return {
                ...state,
                usersListSeenBy: action.payload,
            }
        }
        case UPDATE_NOTICE: {
            console.log('UPDATE NOTICE LIST --->', action.payload.index)
            let payloadIndex = action.payload.index;
            
            const index = state.tableData.findIndex((list) => list.index === payloadIndex); //finding index of the item
            let newArray = [...state.tableData]; //making a new array
            newArray[index] = action.payload//changing value in the new array
            return { 
                ...state, //copying the orignal state
                tableData: newArray, //reassingning todos to new array
            }
        }
        case NOTICE_BOARD_DATA_LIST:{
            return {
                ...state,
                noticeDataList: action.payload,
            }
        }
        case CREATE_NOTICE_BOARD: {
            return {
                ...state,
                tableData: [...state.tableData, action.payload],
            }
        }
        case NOTICE_BOARD_ATTACHMENT: {
            return {
                ...state,
                newAttachment:  action.payload,
            }
        }
        case NOTICE_BOARD_UPDATE_ATTACHMENT: {
            return {
                ...state,
                upDateAttachment:  action.payload,
            }
        }
        case MODAL_DELETE_NOTICE_ACTION: {
            //console.log('DELETE NOTICE REDUCER', action.payload);
            const handleModalHook = state.handleModalHook;
            return {
                ...state,
                noticeDataList: action.payload,
                handleModalHook:!handleModalHook,
                toolTipNoticeOpen: false, 
            }
        }
        case HANDLE_MODAL_HOOK: {
            const handleModalHook = state.handleModalHook;
            return {
                ...state,
                handleModalHook: !handleModalHook,
            }
        }
        case DELETE_NOTICE_ACTION: {
            //console.log('Action Delete', action.payload);
            return {
                ...state,
                //tableData: [...state.tableData.slice(0, action.payload), ...state.tableData.slice(action.payload + 1)],
                tableData : state.tableData.filter(item => action.payload !== item.index),
                //tableData : state.tableData.forEach((item, i) => {item.index = i + 1}),

            }
        }
        case NOTICES_GET_PROJECTS: {
			return {
				...state,
				notices_getProjects: action.payload,
			};
		}
        case NOTICES_GET_PRIVATE_GROUP_TYPE: {
			return {
				...state,
				notices_getGroupTypePrivate: action.payload,
			};
		}
        
        
        default: {
            return state;
        }
        
    }
};
export default noticesReducer;
